const connect = {
	banner: [{
		tips:'联系我们',
		title:'联系方式',
		content:'',
		img: require('@/assets/img/index/GPI_2x.png'),
		url: require('@/assets/img/index/banner01.png'),
	}],		
	adress:'联系地址：中国有色金属行业EPD平台办公室——北京市海淀区复兴路乙12号',
	call:'客服热线：010-63971471',
	email:'邮箱地址：epd_cnia@sina.com'
}

export default connect